module.exports = __webpack_public_path__ + "static/img/before_sixteen.3216114a.png";